var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWptArrowIcon = function SvgWptArrowIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 44,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M53.717 35.497a1 1 0 0 0-.283-1.386l-7.512-4.957a1 1 0 0 0-1.102 1.669l6.677 4.407-4.406 6.676a1 1 0 0 0 1.669 1.102zM2.526 1a1 1 0 1 0-2 0zm50.156 32.966c-14.554 2.981-27.105 1.477-35.978-4.081C7.88 24.357 2.526 14.713 2.526 1h-2c0 14.287 5.617 24.629 15.116 30.58 9.452 5.92 22.58 7.39 37.442 4.345z"
  })));
};
export default SvgWptArrowIcon;